import { ConcatS } from '@helpers/types'
import { achivement } from '@prisma/client'

export namespace profiles {
    type AchivementsSpecs = Record<
        achivement,
        {
            name: ConcatS<['achievements', achivement, 'name'], '.'>
            description: ConcatS<['achievements', achivement, 'description'], '.'>
            feedDescription: ConcatS<['achievements', achivement, 'feedDescription'], '.'>
        }
    >
    export const AchivementsConfig: AchivementsSpecs = {
        FirstSteps: {
            name: 'achievements.FirstSteps.name',
            description: 'achievements.FirstSteps.description',
            feedDescription: 'achievements.FirstSteps.feedDescription',
        },
        RareGem: {
            name: 'achievements.RareGem.name',
            description: 'achievements.RareGem.description',
            feedDescription: 'achievements.RareGem.feedDescription',
        },
        TreasureHunter: {
            name: 'achievements.TreasureHunter.name',
            description: 'achievements.TreasureHunter.description',
            feedDescription: 'achievements.TreasureHunter.feedDescription',
        },
        EpicDiscovery: {
            name: 'achievements.EpicDiscovery.name',
            description: 'achievements.EpicDiscovery.description',
            feedDescription: 'achievements.EpicDiscovery.feedDescription',
        },
        LegendUnearthed: {
            name: 'achievements.LegendUnearthed.name',
            description: 'achievements.LegendUnearthed.description',
            feedDescription: 'achievements.LegendUnearthed.feedDescription',
        },
        MythicalEncounter: {
            name: 'achievements.MythicalEncounter.name',
            description: 'achievements.MythicalEncounter.description',
            feedDescription: 'achievements.MythicalEncounter.feedDescription',
        },
        OneOfAKind: {
            name: 'achievements.OneOfAKind.name',
            description: 'achievements.OneOfAKind.description',
            feedDescription: 'achievements.OneOfAKind.feedDescription',
        },
        DedicatedCollector: {
            name: 'achievements.DedicatedCollector.name',
            description: 'achievements.DedicatedCollector.description',
            feedDescription: 'achievements.DedicatedCollector.feedDescription',
        },
        TrueEnthusiast: {
            name: 'achievements.TrueEnthusiast.name',
            description: 'achievements.TrueEnthusiast.description',
            feedDescription: 'achievements.TrueEnthusiast.feedDescription',
        },
        CollectorExtraordinaire: {
            name: 'achievements.CollectorExtraordinaire.name',
            description: 'achievements.CollectorExtraordinaire.description',
            feedDescription: 'achievements.CollectorExtraordinaire.feedDescription',
        },
        TradingProdigy: {
            name: 'achievements.TradingProdigy.name',
            description: 'achievements.TradingProdigy.description',
            feedDescription: 'achievements.TradingProdigy.feedDescription',
        },
        MasterTrader: {
            name: 'achievements.MasterTrader.name',
            description: 'achievements.MasterTrader.description',
            feedDescription: 'achievements.MasterTrader.feedDescription',
        },
        TradingLegend: {
            name: 'achievements.TradingLegend.name',
            description: 'achievements.TradingLegend.description',
            feedDescription: 'achievements.TradingLegend.feedDescription',
        },
        SocialButterfly: {
            name: 'achievements.SocialButterfly.name',
            description: 'achievements.SocialButterfly.description',
            feedDescription: 'achievements.SocialButterfly.feedDescription',
        },
        NetworkingExpert: {
            name: 'achievements.NetworkingExpert.name',
            description: 'achievements.NetworkingExpert.description',
            feedDescription: 'achievements.NetworkingExpert.feedDescription',
        },
        CompleteSet: {
            name: 'achievements.CompleteSet.name',
            description: 'achievements.CompleteSet.description',
            feedDescription: 'achievements.CompleteSet.feedDescription',
        },
        SetConnoisseur: {
            name: 'achievements.SetConnoisseur.name',
            description: 'achievements.SetConnoisseur.description',
            feedDescription: 'achievements.SetConnoisseur.feedDescription',
        },
        AshesToAshes: {
            name: 'achievements.AshesToAshes.name',
            description: 'achievements.AshesToAshes.description',
            feedDescription: 'achievements.AshesToAshes.feedDescription',
        },
        FireStarter: {
            name: 'achievements.FireStarter.name',
            description: 'achievements.FireStarter.description',
            feedDescription: 'achievements.FireStarter.feedDescription',
        },
        CleansingFlames: {
            name: 'achievements.CleansingFlames.name',
            description: 'achievements.CleansingFlames.description',
            feedDescription: 'achievements.CleansingFlames.feedDescription',
        },
        InfernoMaster: {
            name: 'achievements.InfernoMaster.name',
            description: 'achievements.InfernoMaster.description',
            feedDescription: 'achievements.InfernoMaster.feedDescription',
        },
        BonfireConnoisseur: {
            name: 'achievements.BonfireConnoisseur.name',
            description: 'achievements.BonfireConnoisseur.description',
            feedDescription: 'achievements.BonfireConnoisseur.feedDescription',
        },
        LordOfEmbers: {
            name: 'achievements.LordOfEmbers.name',
            description: 'achievements.LordOfEmbers.description',
            feedDescription: 'achievements.LordOfEmbers.feedDescription',
        },
        RaritySacrifice: {
            name: 'achievements.RaritySacrifice.name',
            description: 'achievements.RaritySacrifice.description',
            feedDescription: 'achievements.RaritySacrifice.feedDescription',
        },
        SuperRarePyre: {
            name: 'achievements.SuperRarePyre.name',
            description: 'achievements.SuperRarePyre.description',
            feedDescription: 'achievements.SuperRarePyre.feedDescription',
        },
        EpicOffering: {
            name: 'achievements.EpicOffering.name',
            description: 'achievements.EpicOffering.description',
            feedDescription: 'achievements.EpicOffering.feedDescription',
        },
        LegendaryCremation: {
            name: 'achievements.LegendaryCremation.name',
            description: 'achievements.LegendaryCremation.description',
            feedDescription: 'achievements.LegendaryCremation.feedDescription',
        },
        MythicalBlaze: {
            name: 'achievements.MythicalBlaze.name',
            description: 'achievements.MythicalBlaze.description',
            feedDescription: 'achievements.MythicalBlaze.feedDescription',
        },
        SolemnFarewell: {
            name: 'achievements.SolemnFarewell.name',
            description: 'achievements.SolemnFarewell.description',
            feedDescription: 'achievements.SolemnFarewell.feedDescription',
        },
        BalancedBurn: {
            name: 'achievements.BalancedBurn.name',
            description: 'achievements.BalancedBurn.description',
            feedDescription: 'achievements.BalancedBurn.feedDescription',
        },
        SetAblaze: {
            name: 'achievements.SetAblaze.name',
            description: 'achievements.SetAblaze.description',
            feedDescription: 'achievements.SetAblaze.feedDescription',
        },
        ScorchedCollection: {
            name: 'achievements.ScorchedCollection.name',
            description: 'achievements.ScorchedCollection.description',
            feedDescription: 'achievements.ScorchedCollection.feedDescription',
        },
        JackOfAllTrades: {
            name: 'achievements.JackOfAllTrades.name',
            description: 'achievements.JackOfAllTrades.description',
            feedDescription: 'achievements.JackOfAllTrades.feedDescription',
        },
        ChikoRokoFanatic: {
            name: 'achievements.ChikoRokoFanatic.name',
            description: 'achievements.ChikoRokoFanatic.description',
            feedDescription: 'achievements.ChikoRokoFanatic.feedDescription',
        },
        ChikoRokoConqueror: {
            name: 'achievements.ChikoRokoConqueror.name',
            description: 'achievements.ChikoRokoConqueror.description',
            feedDescription: 'achievements.ChikoRokoConqueror.feedDescription',
        },
    }
}
